import { explicitMaybe, stringLiteral } from '@execonline-inc/decoders';
import { paginationMetadataDecoder } from '@execonline-inc/resource';
import { Decoder, array, dateISO, field, nullable, number, oneOf, string, succeed } from 'jsonous';
import { readonlyArray } from '../../Decoders';
import { resourceDecoder, resourceWithMetadataDecoder } from '../../Resource/Decoders';
import { registrationTypeDecoder } from '../../components/LearningCollections/LearningCollection/Invitations/Store/Decoders';
import {
  ConsumptionStatus,
  Participant,
  ParticipantResource,
  Participants,
  ParticipantsResource,
  UserProductLicense,
  UserProductLicenseResource,
  UserStatus,
} from '../Types';

export const consumptionStatusDecoder: Decoder<ConsumptionStatus> = oneOf([
  stringLiteral<ConsumptionStatus>('Allocated'),
  stringLiteral<ConsumptionStatus>('Activated'),
]);

export const userProductLicenseDecoder: Decoder<UserProductLicense> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('startOn', field('start_on', dateISO))
  .assign('endOn', field('end_on', dateISO))
  .assign('consumptionStatus', field('consumption_status', consumptionStatusDecoder))
  .assign('registrationType', field('registration_type', registrationTypeDecoder));

export const userProductLicenseResourceDecoder: Decoder<UserProductLicenseResource> =
  resourceDecoder(userProductLicenseDecoder);

export const userStatusDecoder: Decoder<UserStatus> = oneOf([
  stringLiteral<UserStatus>('active'),
  stringLiteral<UserStatus>('disabled'),
]);

const participantDecoder: Decoder<Participant> = succeed({})
  .assign('kind', field('kind', stringLiteral('participant')))
  .assign('id', field('id', number))
  .assign('fullName', field('full_name', nullable(string)))
  .assign('initials', field('initials', explicitMaybe(string)))
  .assign('email', field('email', string))
  .assign('organization', field('organization', string))
  .assign('preferredLanguage', field('preferred_language', nullable(string)))
  .assign('loginCount', field('login_count', number))
  .assign('lastLoginAt', field('last_login_at', nullable(dateISO)))
  .assign('collections', field('collections', array(string)))
  .assign('userGroups', field('user_groups', array(string)))
  .assign('initials', field('initials', explicitMaybe(string)))
  .assign('userGroupsCount', field('user_groups_count', number))
  .assign('activatedLicenseCount', field('activated_license_count', number))
  .assign('licenses', field('licenses', readonlyArray(userProductLicenseResourceDecoder)))
  .assign('status', field('status', userStatusDecoder));

export const participantResourceDecoder: Decoder<ParticipantResource> =
  resourceDecoder(participantDecoder);

const participantsDecoder: Decoder<Participants> = succeed({}).assign(
  'participants',
  field('participants', array(participantResourceDecoder)),
);

export const participantsResourceDecoder: Decoder<ParticipantsResource> =
  resourceWithMetadataDecoder(participantsDecoder, paginationMetadataDecoder);
